//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/**
 * Original Author: Pilar Rust
 * Original Team: Unidrythons
 */
import { NsIcon } from '@nuskin/ns-icon';
import { VCard, VCardTitle, VContainer } from 'vuetify/lib';

export default {
  name: 'NsCard',
  components: { NsIcon, VCard, VCardTitle, VContainer },
  props: {
    hasAction: {
      type: Boolean,
      required: false,
      default: false,
    },
    actionIcon: {
      type: String,
      required: false,
      default: 'icon-close',
    },
    actionString: {
      type: String,
      required: false,
      default: '',
    },
    color: {
      type: String,
      required: false,
      default: '#7123D9',
    },
    context: {
      type: String,
      default: '',
      required: false,
    },
  },
  data() {
    return {};
  },
  computed: {
    headerColor() {
      switch (this.context) {
        case 'danger':
          return '#C81D1D';
        case 'info':
          return '#3783B9';
        case 'success':
          return '#5BAC85';
        case 'warning':
          return '#FD983B';
        default:
          return '#3783B9';
      }
    },
    headerIcon() {
      switch (this.context) {
        case 'danger':
          return 'icon-exclamation';
        case 'success':
          return 'icon-success-filled';
        case 'warning':
          return 'icon-warning-filled';
        case 'info':
          return 'icon-info-filled';
        default:
          return '';
      }
    },
  },
};
